module.exports = __webpack_public_path__ + "img/boller.3c7b9363.jpg";